<template>
    <div class="ok-loading" :class="{ 'disappear':!loadingShow }" v-if="domShow">
        <div class="loading-main">
            <img src="@/static/img/logo.png" />
            <div class="shadow">
                
            </div>
        </div>
        <div class="width loading-text">
            <span class="gray">{{text || '请稍候'}}</span>
        </div>
    </div>
</template>
<script>
export default {
    name: 'loading-view',
    data(){
        return {
            loadingShow: false,
            domShow: false,
        }
    }, 
    methods: {
        disappear() {
            this.loadingShow = false;
            setTimeout(() => {
                this.domShow = false;
            }, 600);
        }
    },
    watch: {
        show(value){
            if(!value){
                this.disappear();
            }else{
                this.loadingShow = true;
                this.domShow = true;
            }
        }
    },
    props :['show','text']
}
</script>

<style>
.ok-loading {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: #fff;
    transition: opacity 0.3s ease;
    opacity: 1;
    z-index: 10;
}
.ok-loading.disappear {
    opacity: 0;
}
.loading-main {
    width: 3.75rem /* 45/12 */;
    height: 3.75rem /* 45/12 */;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
}
.ok-loading .loading-main .cover {
    width: 3.75rem /* 45/12 */;
    height: 3.75rem /* 45/12 */;
    position: absolute;
    top: 0;
    left: 0;
    background: #fff;
    z-index: 2;
}
.ok-loading .loading-main img {
    width: 45px;
    height: 45px;
    display: block;
    vertical-align: top;
    transform-origin: center;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 10;
    animation: jump 1s;
    -webkit-animation: jump 1s;
    animation-iteration-count: infinite;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-timing-function: ease-in-out;
    animation-timing-function: ease-in-out;
    will-change: auto;
}
.ok-loading .loading-main .shadow {
    width: 1.666667rem /* 20/12 */;
    height: 1.666667rem /* 20/12 */;
    border-radius: 50%;
    transform: rotateX(45deg);
    -webkit-transform: rotateX(45deg);
    background: #464646;
    position: absolute;
    bottom: -.833333rem /* 10/12 */;
    margin: auto;
    left: 0;
    right: 0;
    z-index: 1;
    animation: scale 1s;
    will-change: auto;
    -webkit-animation: scale 1s;
    animation-iteration-count: infinite;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-timing-function: ease-in-out;
    animation-timing-function: ease-in-out;
}
.ok-loading .loading-text{
    width: 100%;
    position: absolute;
    top: 56%;
    left: 0;
    text-align: center;
}
@keyframes scale {
    0% {
        transform: rotateX(45deg) scale(1);
        -webkit-transform: rotateX(45deg) scale(1);
    }
    50% {
        transform: rotateX(45deg) scale(0);
        -webkit-transform: rotateX(45deg) scale(0);
    }
    100% {
        transform: rotateX(45deg) scale(1);
        -webkit-transform: rotateX(45deg) scale(1);
    }
}
@-webkit-keyframes scale {
    0% {
        transform: rotateX(45deg) scale(1);
        -webkit-transform: rotateX(45deg) scale(1);
    }
    50% {
        transform: rotateX(45deg) scale(0);
        -webkit-transform: rotateX(45deg) scale(0);
    }
    100% {
        transform: rotateX(45deg) scale(1);
        -webkit-transform: rotateX(45deg) scale(1);
    }
}
@keyframes jump {
    0% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-1.666667rem /* 20/12 */);
    }
    100% {
        transform: translateY(0);
    }
}
@-webkit-keyframes jump {
    0% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-1.666667rem /* 20/12 */);
    }
    100% {
        transform: translateY(0);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/loadView.vue